<template>
    <dropdown
        ref="dropdown"
        :position="position"
        :icon="icon ? icon : ''"
        :class="classes"
        :text="text"
        :isIntegration="isIntegration ? isIntegration : false"
        :isButton="isButton"
        class="merge-fields"
        keep-open-after-select
        @icon-click-after="iconClickAfter"
    >
        <label v-if="!isFallbackModal" class="label">Merge Fields</label>
        <label v-else class="label merge-fields-fallback-label">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="10"
                viewBox="0 0 12 10"
                fill="none"
            >
                <path
                    d="M11.4999 3.75C11.4988 4.61163 11.1561 5.43766 10.5468 6.04693C9.93757 6.65619 9.11153 6.99894 8.24991 7H2.20691L3.85341 8.6465C3.90116 8.69262 3.93925 8.7478 3.96546 8.8088C3.99166 8.8698 4.00545 8.93541 4.00603 9.0018C4.00661 9.06819 3.99396 9.13403 3.96882 9.19548C3.94368 9.25692 3.90655 9.31275 3.8596 9.3597C3.81266 9.40664 3.75683 9.44377 3.69538 9.46891C3.63393 9.49405 3.56809 9.5067 3.5017 9.50613C3.43532 9.50555 3.36971 9.49175 3.3087 9.46555C3.2477 9.43935 3.19253 9.40126 3.14641 9.3535L0.646405 6.8535C0.599842 6.80705 0.562899 6.75188 0.537693 6.69113C0.512487 6.63039 0.499512 6.56527 0.499512 6.4995C0.499512 6.43373 0.512487 6.36861 0.537693 6.30787C0.562899 6.24712 0.599842 6.19195 0.646405 6.1455L3.14641 3.6455C3.24071 3.55442 3.36701 3.50402 3.49811 3.50516C3.6292 3.5063 3.75461 3.55889 3.84731 3.65159C3.94002 3.74429 3.9926 3.8697 3.99374 4.0008C3.99488 4.1319 3.94448 4.2582 3.85341 4.3525L2.20691 6H8.24991C8.84664 6 9.41894 5.76295 9.8409 5.34099C10.2629 4.91903 10.4999 4.34674 10.4999 3.75C10.4999 3.15326 10.2629 2.58097 9.8409 2.15901C9.41894 1.73705 8.84664 1.5 8.24991 1.5H5.99991C5.8673 1.5 5.74012 1.44732 5.64635 1.35355C5.55258 1.25979 5.49991 1.13261 5.49991 1C5.49991 0.867392 5.55258 0.740215 5.64635 0.646447C5.74012 0.552678 5.8673 0.5 5.99991 0.5H8.24991C9.11153 0.501059 9.93757 0.843808 10.5468 1.45307C11.1561 2.06234 11.4988 2.88837 11.4999 3.75Z"
                    fill="black"
                />
            </svg>
            <span class="ml-6">Fallback</span>
        </label>
        <div
            class="merge-fields-save-fallback"
            :class="{
                'is-hidden': !isFallbackModal,
            }"
        >
            <input
                id="merge-field-input"
                ref="mergeFieldInput"
                v-model="fallbackMsg"
                :maxlength="100"
                type="text"
                class="input"
                placeholder="Enter"
            />
            <a class="merge-fields-save-fallback-btn" @click="saveFallbackMsg">Save</a>
        </div>
        <template v-if="!isFallbackModal">
            <div v-if="searchOnTop" class="dropdown-item is-no-hover merge-fields-search">
                <input v-model="query" type="text" class="input" placeholder="Search..." />
                <a class="merge-fields-clear" @click="query = ''">
                    <fa-icon icon="times" />
                </a>
            </div>
            <merge-fields-item
                v-for="(item, index) in displayedResults"
                :key="index"
                :item="item"
                :index="index"
                :hasNotIntegration="hasNotIntegration"
                :template="template"
                :checkDate="checkDate"
                @apply-merge-field="applyMergeField"
            />
            <div
                v-if="displayedResults.length === 0"
                class="dropdown-item is-no-hover is-no-results"
            >
                <div class="help has-text-danger">No Results</div>
            </div>
            <div v-if="!searchOnTop" class="dropdown-item is-no-hover merge-fields-search">
                <input v-model="query" type="text" class="input" placeholder="Search..." />
                <a class="merge-fields-clear" @click="query = ''">
                    <fa-icon icon="times" />
                </a>
            </div>
        </template>
    </dropdown>
</template>

<script>
import { debounce } from 'lodash';
import moment from 'moment';
import { mapState } from 'pinia';
import stores from 'store/modules';
import MergeFieldsItem from './MergeFieldsItem';

export default {
    emits: ['selected'],
    
    components: {
        MergeFieldsItem,
    },

    props: {
        template: { type: Boolean, default: false },
        position: { type: String, default: 'left' },
        icon: { type: [String, Boolean], default: false },
        text: { type: String, default: '' },
        integration: { type: Object },
        conversation: { type: Object },
        default: { type: [Array, String], required: true },
        isIntegration: { type: Boolean, required: false },
        isButton: { type: Boolean, default: false },
        fields: { type: Array, default: () => [] },
        useAllField: { type: Boolean, default: false },
    },

    data: () => ({
        busy: false,
        query: '',
        results: [],
        isFallbackModal: false,
        fallbackItem: null,
        fallbackMsg: '',
    }),

    computed: {
        searchOnTop() {
            return this.position.indexOf('bottom') !== -1;
        },

        classes() {
            return {
                'is-busy': this.busy,
                'has-results': !this.busy && this.query && this.displayedResults !== null,
            };
        },

        displayedResults() {
            let fields = Array.isArray(this.default) ? this.default.map((item) => item) : [];

            if (this.integration) {
                if (!this.template) {
                    if (!this.results.length) {
                        if (!this.query) {
                            return fields.splice(0, 7);
                        }

                        return fields
                            .filter(
                                (o) =>
                                    o.label.toLowerCase().indexOf(this.query.toLowerCase()) !==
                                    -1 && o.value
                            )
                            .splice(0, 7);
                    }

                    if (this.conversation) {
                        return this.results.filter((o) => o.value).splice(0, 7);
                    }

                    return this.results.splice(0, 7);
                }

                if (this.useAllField) {
                    if (!this.query) {
                        return fields.splice(0, 7);
                    } else {
                        return [...fields, ...this.fields]
                            .filter(
                                (o) =>
                                    o.label.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
                            )
                            .splice(0, 7);
                    }
                }

                if (!this.query) {
                    return fields;
                } else {
                    return this.fields
                        .filter(
                            (o) => o.label.toLowerCase().indexOf(this.query.toLowerCase()) !== -1
                        )
                        .splice(0, 7);
                }
            }

            if (this.query) {
                if (this.fields.length) {
                    fields = this.fields.map((item) => item);
                }

                return fields
                    .filter((o) => o.label.toLowerCase().indexOf(this.query.toLowerCase()) !== -1)
                    .splice(0, 7);
            }

            return fields.splice(0, 7);
        },

        ...mapState(stores.User, ['user']),
    },

    watch: {
        query() {
            if (this.integration) {
                this.search();
            }
        },

        default() {
            this.query = '';
        },

        isFallbackModal(isOpen) {
            if (isOpen) {
                this.$refs.mergeFieldInput.focus();
            }
        },
    },

    methods: {
        search() {
            if (this.template) {
                return;
            }

            if (!this.query) {
                this.debounceSearch.cancel();
            }

            if (this.query) {
                this.debounceSearch();
            } else {
                this.results = [];
            }
        },

        iconClickAfter(e) {
            if (e) e.stopPropagation();
            this.fallbackItem = null;
            this.fallbackMsg = '';
            this.isFallbackModal = false;
        },

        async handleSearch() {
            try {
                this.busy = true;

                const params = {
                    query: this.query,
                };

                let response;

                if (this.conversation) {
                    response = await this.$store.dispatch('getIntegrationsByIdMergeFields', {
                        id: this.conversation.contact.id,
                        params: params,
                    });
                } else {
                    response = await this.$store.dispatch('getIntegrationsByIdFields', {
                        id: this.integration.key,
                        params: params,
                        update: false,
                    });
                }

                this.results = response;
                this.$nextTick(() => {
                    this.$refs.dropdown.attachClickListeners();
                });
            } catch (e) {
                this.$log.error(e, this.$options.__file, 'handleSearch');
            } finally {
                this.busy = false;
            }
        },

        ucFirst(str) {
            if (!str) return str;

            return str[0].toUpperCase() + str.slice(1);
        },

        ucFirstAndLast(str) {
            if (!str) return str;

            return str
                .split(' ')
                .map((item) => item[0].toUpperCase() + item.slice(1))
                .join(' ');
        },

        switchName(name, value) {
            switch (name) {
                case 'first_name':
                case 'firstname':
                case 'FirstName':
                case 'last_name':
                case 'lastname':
                case 'LastName':
                    return this.ucFirst(value);
                case 'name':
                    return this.ucFirstAndLast(value);
            }
        },

        saveFallbackMsg() {
            if (!this.fallbackItem) return;

            let newTemplate = this.fallbackItem.template;

            if (this.fallbackMsg) {
                newTemplate = this.fallbackItem.template.replace(
                    ' }',
                    ` | '${this.fallbackMsg}' }`
                );
            }

            if (this.hasNotIntegration(this.fallbackItem)) return;

            this.query = '';
            this.$emit('selected', this.checkDate(newTemplate).join(' '));

            this.fallbackItem = null;
            this.fallbackMsg = '';
            this.isFallbackModal = false;

            this.$store.dispatch('dropdownClose');
        },

        applyMergeField(item) {
            if (this.hasNotIntegration(item)) return;

            if (item.value && this.switchName(item.name, item.value)) {
                item.value = this.switchName(item.name, item.value);
            }

            if (item.template) {
                this.query = '';

                this.fallbackItem = item;
                this.isFallbackModal = true;

                return;
            }

            this.query = '';

            const value = this.template
                ? this.checkDate(item.template).join(' ')
                : this.checkDate(item.value).join(' ');

            this.$emit('selected', value, item);
        },

        checkDate(_str) {
            if (!_str) return [];

            let strSplit = String(_str).split(' ');
            let endValue = strSplit.map((e) => {
                if (moment(e, 'YYYY-MM-DD').format('YYYY-MM-DD') === e) {
                    return moment(e).format('MM/DD/YYYY');
                }
                return e;
            });
            return endValue;
        },

        hasNotIntegration(item) {
            if (!item.integrationKey) return false;

            return !this.hasIntegrationUser(item.integrationKey);
        },

        handleDocumentKeydown(e) {
            if (e.keyCode === 13) {
                this.saveFallbackMsg();
            }
        },
    },

    mounted() {
        this.debounceSearch = debounce(this.handleSearch, 500);

        document.body.addEventListener('click', (e) => {
            this.fallbackItem = null;
            this.fallbackMsg = '';
            this.isFallbackModal = false;
        });

        document.body.addEventListener('keydown', this.handleDocumentKeydown);
    },

    beforeUnmount() {
        document.body.removeEventListener('click', (e) => {});
        document.body.removeEventListener('keydown', this.handleDocumentKeydown);
    },
};
</script>
